<template>
  <div class="content content-fixed">
    <div class="container pd-x-0 pd-lg-x-10 pd-xl-x-0">
      <div
        class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30"
      >
        <div>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-style1 mg-b-10">
              <li class="breadcrumb-item"><a href="#">Тавтай морил</a></li>
              <li class="breadcrumb-item active" aria-current="page">
                Хяналтын самбар
              </li>
            </ol>
          </nav>
          <h4 class="mg-b-0 tx-spacing--1">
            Шалган зааварлагчийн модулийн удирдлагын хяналт
          </h4>
        </div>
        <div class="d-none d-md-block">
          <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase">
            <feather type="menu"></feather> Эхлэл
          </button>
          <router-link to="/tr/travel/557/0/0/0/0/0" class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5">
            <feather type="menu"></feather> Аялал
          </router-link>
        </div>
      </div>

      <div class="row row-xs">
        <div class="col-sm-6 col-lg-3">
          <div class="card card-body">
            <h6
              class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8"
            >
              Аялал
            </h6>
            <div class="d-flex d-lg-block d-xl-flex align-items-end">
              <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">
                {{ stat.travelsCount }}
              </h3>
            </div>
          </div>
        </div>
        <!-- col -->
        <div
          class="col-sm-6 col-lg-3 mg-t-10 mg-sm-t-0"
          v-for="(s, i) in stat.hrCountsByPositionType"
        >
          <div class="card card-body">
            <h6
              class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8"
            >
              {{ s.name }}
            </h6>
            <div class="d-flex d-lg-block d-xl-flex align-items-end">
              <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">
                {{ s.count }}
              </h3>
            </div>
          </div>
        </div>
        <!-- col -->

        <div class="col-xl-4 mg-t-10 order-md-1 order-xl-0">

        
          <div class="card ht-lg-100p">
            <div
              class="card-header d-flex align-items-center justify-content-between"
            >
              <h6 class="mg-b-0">Аялалын чиглэлүүд</h6>
              <!-- <div class="tx-13 d-flex align-items-center">
                  <span class="mg-r-5">Country:</span> <a href="" class="d-flex align-items-center link-03 lh-0">USA <i class="icon ion-ios-arrow-down mg-l-5"></i></a>
                </div> -->
            </div>
            <!-- card-header -->
            <div class="card-body pd-0">
              <div class="">
                <!-- <iframe
                  style="width: 100%; border: 0; height: 200px"
                  src="/html/mori/map.html"
                ></iframe> -->
                <img src="https://res.gosmart.mn/static/railway/rlwayhome.jpg?w=400" class="wd-100p" />
              </div>

              <div class="card mg-20 card-widget card-todo">
                  <div class="card-header d-flex justify-content-between">
                    <h6 class="lh-5 mg-b-0">Эхэлсэн аяллууд</h6>
                  </div>
                  <!-- card-header -->
                  <div class="card-body pd-0" style="padding: 0px;">
                    <ul class="list-group list-group-flush">
                      <li
                        @click="showTask(t)"
                        role="button"
                        class="list-group-item"
                        v-for="(t, i) in travelsInTime"
                        :key="i"
                      >
                        <div class="list-group-header">
                          <!-- <span class="bg-purple"></span>
                  <span class="bg-success"></span> -->
                          <a class="link-01" v-if="t.from != null">{{
                            t.from.name
                          }}</a>
                          <a class="link-01 mg-l-auto" v-if="t.to != null">{{
                            t.to.name
                          }}</a>
                        </div>
                        <h6 class="todo-title"></h6>
                        <div class="d-flex justify-content-between">
                          <span class="todo-date">
                           
                            {{ t.dueStartDate | moment("MM/DD HH:mm") }}
                          </span>
                          <span class="todo-date mg-l-auto">
                           
                            {{ t.dueDate | moment("MM/DD HH:mm") }}
                          </span>
                        </div>

                        <div class="card-progress">
                          <label class="content-label mg-b-0">Явц</label>
                          <div class="progress">
                            <div
                              class="progress-bar"
                              :style="`width: ${t.process}%`"
                              role="progressbar"
                              aria-valuenow="0"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                          <label class="content-label mg-b-0">{{t.process.toFixed(2) }}%</label>
                        </div>

                        <div class="d-flex wd-100p justify-content-between">
                          <div class="text-center" style="width: 33%">
                            <div
                              class=""
                              v-if="t.trainer != null"
                            >
                              <img
                                :src="t.trainer.avator"
                                class="rounded-circle"
                                alt=""
                              />
                            </div>
                            <span class="text-muted tx-12"> Зааварлагч</span>
                            <div class="tx-12" v-if="t.trainer!=null"> {{ t.trainer.firstName }}</div>
                          </div>
                          <div class="text-center" style="width: 33%">
                            <div
                              class=""
                              v-if="t.jolooch != null"
                            >
                              <img
                                :src="t.jolooch.avator"
                                class="rounded-circle"
                                alt=""
                              />
                            </div>
                            <span class="text-muted tx-12">Машинч</span>
                            <div class="tx-12" v-if="t.jolooch!=null"> {{ t.jolooch.firstName }}</div>
                          </div>
                          <div class="text-center" style="width: 33%">
                            <div
                              class=""
                              v-if="t.tuslakh != null"
                            >
                              <img
                                :src="t.tuslakh.avator"
                                class="rounded-circle"
                                alt=""
                              />
                            </div>
                            <span class="text-muted tx-12">Туслах машинч</span>
                            <div class="tx-12" v-if="t.tuslakh!=null"> {{ t.tuslakh.firstName }}</div>
                          </div>

                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="card mg-20 card-widget card-todo">
                  <div class="card-header d-flex justify-content-between bg-success">
                    <h6 class="lh-5 mg-b-0 text-white">Сүүлд дууссан аяллууд</h6>
                  </div>
                  <!-- card-header -->
                  <div class="card-body pd-0" style="padding: 0px;">
                    <ul class="list-group list-group-flush">
                      <li
                        @click="showTask(t)"
                        role="button"
                        class="list-group-item"
                        v-for="(t, i) in travelsDone"
                        :key="i"
                      >
                        <div class="list-group-header">
                          <!-- <span class="bg-purple"></span>
                  <span class="bg-success"></span> -->
                          <a class="link-01" v-if="t.from != null">{{
                            t.from.name
                          }}</a>
                          <a class="link-01 mg-l-auto" v-if="t.to != null">{{
                            t.to.name
                          }}</a>
                        </div>
                        <h6 class="todo-title"></h6>
                        <div class="d-flex justify-content-between">
                          <span class="todo-date">
                           
                            {{ t.dueStartDate | moment("MM/DD HH:mm") }}
                          </span>
                          <span class="todo-date mg-l-auto">
                           
                            {{ t.dueDate | moment("MM/DD HH:mm") }}
                          </span>
                        </div>

                        <div class="d-flex wd-100p justify-content-between">
                          <div class="text-center" style="width: 33%">
                            <div
                              class=""
                              v-if="t.trainer != null"
                            >
                              <img
                                :src="t.trainer.avator"
                                class="rounded-circle"
                                alt=""
                              />
                            </div>
                            <span class="text-muted tx-12"> Зааварлагч</span>
                            <div class="tx-12" v-if="t.trainer!=null"> {{ t.trainer.firstName }}</div>
                          </div>
                          <div class="text-center" style="width: 33%">
                            <div
                              class=""
                              v-if="t.jolooch != null"
                            >
                              <img
                                :src="t.jolooch.avator"
                                class="rounded-circle"
                                alt=""
                              />
                            </div>
                            <span class="text-muted tx-12">Машинч</span>
                            <div class="tx-12" v-if="t.jolooch!=null"> {{ t.jolooch.firstName }}</div>
                          </div>
                          <div class="text-center" style="width: 33%">
                            <div
                              class=""
                              v-if="t.tuslakh != null"
                            >
                              <img
                                :src="t.tuslakh.avator"
                                class="rounded-circle"
                                alt=""
                              />
                            </div>
                            <span class="text-muted tx-12">Туслах машинч</span>
                            <div class="tx-12" v-if="t.tuslakh!=null"> {{ t.tuslakh.firstName }}</div>
                          </div>

                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

              <!-- table-responsive -->
            </div>
            <!-- card-body -->
          </div>
          <!-- card -->
        </div>
        <!-- col -->
        <div class="col-xl-8 mg-t-10">
          <div class="card mg-b-10">
            <div
              class="card-header pd-t-20 d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-0"
            >
              <div>
                <h6 class="mg-b-5">Төлөвлөгөө биелэлт</h6>
                <p class="tx-13 tx-color-03 mg-b-0">
                  ШЗА, Зорилгот аялал, Зүгшрүүлэлт
                </p>
              </div>
              <!-- <div class="d-flex mg-t-20 mg-sm-t-0">
                <div class="btn-group flex-fill">
                  <button class="btn btn-white btn-xs active">
                    Хугацаагаар
                  </button>
                  <button class="btn btn-white btn-xs">Үнэлгээгээр</button>
                </div>
              </div> -->

              <div class="ml-auto d-flex align-items-center">
                <div>он: </div> 
                <select @change="yrChangee" v-model="curYear" class="form-control mg-l-5">
                  <option v-for="(y,yi) in yrs" :key="yi" :value="y" :label="`${y}-он`"></option>
                </select>
              </div>
            </div>
            <!-- card-header -->
            <div class="card-body pd-y-30">
              <div class="d-sm-flex">
                <div class="media">
                  <div
                    class="wd-40 wd-md-50 ht-40 ht-md-50 bg-teal tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-6"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-bar-chart-2"
                    >
                      <line x1="18" y1="20" x2="18" y2="10"></line>
                      <line x1="12" y1="20" x2="12" y2="4"></line>
                      <line x1="6" y1="20" x2="6" y2="14"></line>
                    </svg>
                  </div>
                  <div class="media-body">
                    <h6
                      class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8"
                    >
                      Хугцаандаа биелсэн
                    </h6>
                    <h4
                      class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0"
                    >
                      {{ stat.inTimeDoneCount }}
                    </h4>
                  </div>
                </div>
                <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                  <div
                    class="wd-40 wd-md-50 ht-40 ht-md-50 bg-pink tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-5"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-bar-chart-2"
                    >
                      <line x1="18" y1="20" x2="18" y2="10"></line>
                      <line x1="12" y1="20" x2="12" y2="4"></line>
                      <line x1="6" y1="20" x2="6" y2="14"></line>
                    </svg>
                  </div>
                  <div class="media-body">
                    <h6
                      class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8"
                    >
                      Хугацаа хэтэрч биелсэн
                    </h6>
                    <h4
                      class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0"
                    >
                      {{ stat.overTimeDoneCount }}
                    </h4>
                  </div>
                </div>
                <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                  <div
                    class="wd-40 wd-md-50 ht-40 ht-md-50 bg-primary tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-4"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-bar-chart-2"
                    >
                      <line x1="18" y1="20" x2="18" y2="10"></line>
                      <line x1="12" y1="20" x2="12" y2="4"></line>
                      <line x1="6" y1="20" x2="6" y2="14"></line>
                    </svg>
                  </div>
                  <div class="media-body">
                    <h6
                      class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8"
                    >
                      Хүлээгдэж буй
                    </h6>
                    <h4
                      class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0"
                    >
                      {{ stat.awaitingCount }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <!-- card-body -->
    <!-- {{ mode }} -->
            <div class="table-responsive">
              <div
                v-if="mode == 1"
                class="d-flex align-items-center mg-b-5 bg-dark pd-10"
              >
                <button
                  @click="mode = 0"
                  class="btn btn-outline-light btn-xs mg-x-10"
                >
                  Буцах
                </button>
                <div class="mg-l-auto d-flex align-items-center">
                  <span class="text-muted">Зааварлагч: </span>
                  <select
                    @change="trainerChanged"
                    v-model="trainerCurId"
                    class="form-control mg-l-5"
                  >
                    <option :value="null">-- Зааварлагчид --</option>
                    <option
                      v-for="(t, i) in tasks"
                      :key="i"
                      :value="t.userId"
                      >{{ t.task }}</option
                    >
                  </select>
                </div>
                <div class="mg-l-10">
                  <a
                    @click="modalDriverFilter = true"
                    role="button"
                    class="btn btn-white"
                  >
                    <feather type="search"></feather>
                    Машинист хайх ({{ tasks3.length }})
                  </a>
                </div>
                <div class="mg-l-10 d-flex align-items-center">
                  <span class="text-muted">Цуваа: </span>
                  <select
                    @change="departChanged"
                    v-model="departCurId"
                    class="form-control mg-l-5"
                  >
                    <!-- <option :value="null">-- Бух цуваа --</option> -->
                    <option v-for="(d, i) in departs" :key="i" :value="d.id">{{
                      d.label
                    }}</option>
                  </select>
                </div>
              </div>
              <table
                class="table table-sm table-bordered table-hover table-striped table-dashboard mg-b-0"
              >
                <thead class="tx-11">
                  <tr>
                    <th>№</th>
                    <th class="text-center">
                      {{ mode == 0 ? "Заааварлагч" : "Машинист" }}
                    </th>
                    <th v-for="m in 12" class="text-center bg-gray-500 lh-1">
                      {{ m }}-р сар
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-for="(t, i) in mode == 0 ? tasks : tasks3Filtered"
                  >
                    <tr v-show="isDrawGroup(i)">
                      <td colspan="14" class="pd-5-f">
                        <div class="d-flex align-items-center">
                          {{
                            mode == 0 ? t.user.departParentName : t.departName
                          }}
                          <!-- <button
                            v-if="mode == 0"
                            @click="
                              filterByTrainer({
                                userId: t.user.id,
                                departId: t.user.departParentId,
                              })
                            "
                            class="btn btn-xs btn-white mg-l-auto"
                          >
                            Бүгдийг харах
                          </button> -->
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="tx-color-03 tx-normal">{{ i + 1 }}</td>
                      <td class="tx-medium pd-5-f">
                        <div
                          @click="filterByTrainer(t)"
                          class="d-flex"
                          role="button"
                        >
                          <div
                            class="avatar rounded-circle pd-2 bd bg-white wd-30 ht-30 mg-r-5"
                          >
                            <img
                              :src="`${t.defaultAttachmentUrl}?w=40&mode=crop`"
                              class="rounded-circle"
                            />
                          </div>
                          <div>
                            <div class="tx-11">{{ t.user.fullName }}</div>
                            <div class="text-muted text-truncate tx-10">
                              {{ mode == 0 ? t.departName : t.position }}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td
                        v-for="m in 12"
                        class="text-center pd-0-f"
                        style="height: 1px"
                      >
                        <div class="pos-relative ht-100p" v-if="mode == 1">
                          <div
                            @click="showTaskDtl(t, m)"
                            role="button"
                            :class="
                              `font-weight-bold tx-22 pd-x-5 pd-y-5 ${getBgDriver(
                                t,
                                m
                              )}`
                            "
                          >
                            {{ fillPlanDriver(t, m) }}
                          </div>
                          <div class="dropdown pos-absolute r-0 t-0 trdrp">
                            <button style="background: rgba(0,0,0,0.05)"
                              class="pd-0 btn dropdown-toggle"
                              type="button"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <feather type="menu" style="width: 12px; height: 12px"></feather>
                            </button>
                            <div
                              class="dropdown-menu tx-13"
                              x-placement="bottom-start"
                              style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(0px, 38px, 0px);"
                            >
                              <h6
                                class="dropdown-header tx-uppercase tx-11 tx-bold tx-inverse tx-spacing-1 bd-b text-muted"
                              >
                                {{ t.task }}
                              </h6>
                              <!-- <a @click="createPlan(t,m)" class="dropdown-item" role="button">Төлөвлөх</a> -->

                              <template v-if="planDriverExists(t, m)">
                                <a
                                  @click="insertExec(t, m)"
                                  class="dropdown-item bg-info text-white"
                                  role="button"
                                >
                                  <feather type="pen-tool"></feather>
                                  Биелэлт оруулах
                                </a>
                                <div class="dropdown-divider"></div>
                              </template>

                              <a
                                @click="createPlan(t, m, tp)"
                                v-for="(tp, i) in types"
                                :key="i"
                                class="dropdown-item"
                                role="button"
                              >
                                <feather type="arrow-right"></feather>
                                {{ tp.title }}
                              </a>

                              <div class="dropdown-divider"></div>
                              <a
                                @click="
                                  $router.push(`/tr/travel/557/0/0/0/${t.id}/0`)
                                "
                                class="dropdown-item"
                                role="button"
                              >
                                <feather type="list"></feather>
                                Төлөвлөгөө харах
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          v-else-if="mode == 0"
                          :class="
                            `ht-100p pd-x-5 pd-y-5 tx-20 text-center ${getBgTrainer(
                              t,
                              m
                            )}`
                          "
                        >
                          {{ fillPlanTrainer(t, m) }}
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <!-- table-responsive -->
          </div>
          <!-- card -->
        </div>
        <!-- col -->
      </div>
    </div>

    <b-modal
      v-model="taskDtl.mdl"
      size="xl"
      hide-footer
      hide-header
      content-class="rounded-20 pd-20"
    >
      <h3>{{ taskDtl.obj.task }}</h3>
      <div v-html="taskDtl.obj.taskDesc"></div>
    </b-modal>

    <b-modal
      v-model="modalDriverFilter"
      centered
      title="Машинист хайх"
      scrollable
    >
      <div class="bd">
        <div class="d-flex ht-45 pd-x-15 align-items-center bd-b">
          <input
            v-model="textSearch"
            type="search"
            class="form-control bd-0 pd-0 shadow-none-f"
            placeholder="Нэрээр хайх"
          />
          <feather type="search" style="width: 16px; height: 16px"></feather>
        </div>

        <ul class="list-unstyled media-list tx-12 tx-sm-13 mg-b-0">
          <li
            class="media bg-ui-01 pd-y-10 pd-x-15 mg-b-2"
            v-for="(t, i) in tasks3Filter"
            :key="i"
          >
            <div class="avatar">
              <img
                :src="`${t.defaultAttachmentUrl}?w=50&mode=crop`"
                class="rounded-circle"
                alt=""
              />
            </div>
            <div class="media-body mg-l-15">
              <h6 class="tx-13 mg-b-2">{{ t.task }}</h6>
              <span class="d-block tx-color-03">{{ t.position }}</span>
            </div>
            <!-- media-body -->
            <a
              @click="
                textSearch = '';
                idSearch = t.id;
              "
              role="button"
              class="btn btn-white rounded-circle btn-icon mg-l-15"
            >
              <feather type="eye"></feather>
            </a>
          </li>
        </ul>
      </div>
      <template #modal-footer>
        <button
          @click="
            textSearch = '';
            idSearch = null;
            modalDriverFilter = false;
          "
          class="btn btn-white"
        >
          Бүх машинист
        </button>
        <button
          @click="modalDriverFilter = false"
          class="btn btn-white mg-l-auto"
        >
          Хаах
        </button>
      </template>
    </b-modal>

    <task-edit
      :prms.sync="taskEdit"
      :show.sync="taskEdit.show"
      @on-edit-close="editClosed"
      @on-task-posted="taskPosted"
    ></task-edit>

    <taskDialog
      :show.sync="taskDialogDtl.show"
      :id="taskDialogDtl.id"
      :key="taskDialogDtl.key"
      v-if="taskDialogDtl.id > 0"
      @on-hide="
        taskDialogDtl.show = false;
        taskDialogDtl.id = 0;
      "
    />
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { request } from "@/api/all";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import { getTypeTreeData } from "@/api/type";

var _ = require("lodash");
const moment = require("moment");

export default {
  components: {
    chartMixed: () => ({
      component: import("@/views/home/apps/mori/charts/mixed.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    chartMixed1: () => ({
      component: import("@/views/home/apps/mori/charts/mixed1.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskEdit: () => ({
      component: import("@/components/task/edit/base"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskDialog: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 15000,
    }),
  },
  data() {
    return {
      yrs: [],
      taskDialogDtl: {
        show: false,
        id: 0,
        key: 0,
      },
      modalDriverFilter: false,
      types: [],
      curYear: null,

      trainerCurId: null,
      departCurId: null,
      departParentId: null,

      planTrainer: [],
      planDriver: [],
      taskEdit: {
        show: false,
        id: 0,
        render: false,
        objectTypeId: 0,
        projectId: 0,
        parentId: 0,
        parentTask: {},
        fillAfter: {},
      },
      mode: 0,
      tasks: [],
      tasks2: [],
      tasks3: [],

      taskDtl: {
        obj: {
          task: null,
          defaultAttachmentUrl: null,
          taskDesc: null,
        },
        mdl: false,
      },
      departs: [],

      textSearch: "",
      idSearch: null,
      departParentId: null,

      travelsDone: [],
      travelsInTime: [],
      stat: {
        awaitingCount: null,
        hrCountsByPositionType: [],
        inTimeDoneCount: null,
        overTimeDoneCount: null,
        travelsCount: null,
      },
    };
  },

  computed: {
    tasks3Filter: function() {
      var textSearch = this.textSearch;
      return this.tasks3.filter(function(el) {
        return el.task.toLowerCase().indexOf(textSearch.toLowerCase()) !== -1;
      });
    },
    tasks3Filtered: function() {
      if (this.idSearch != null) {
        return this.tasks3.filter((x) => x.id == this.idSearch);
      } else return this.tasks3;
    },
  },

  mounted() {
    this.curYear = moment().format('YYYY');
    const startYear = 2023;
    const endYear = this.curYear;
    this.yrs= Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);

    let _obj = this.$store.state.app.mainLayoutConfig;
    //console.log('obj', _obj)
    _obj.aside = false;
    _obj.header = 201;
    _obj.expanded = false;
    this.handleMainLayoutConfig(_obj);

    getTypeTreeData({
      params: { key: "tr_travelType" },
      store: this.$store,
    }).then((res) => {
      if (res != false) {
        this.types = res.data.types;
        this.init();
      }
    });

    this.getInTimeTravelList();
  },
  methods: {
    yrChangee(){
      this.init();
      // this.getInTimeTravelList();
    },
    ...mapActions(["handleLoading", "handleMainLayoutConfig"]),
    getInTimeTravelList() {
      request({
        api: { method: "POST", url: "UBTZ/TravelDashboard" },
        data: {
          year: this.curYear,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          //console.log("TravelDashboard", res);
          this.stat = res.data;
        }
      });

      this.handleLoading({ isLoading: true });
      request({
        api: { method: "POST", url: "UBTZ/GetInTimeTravelList" },
        data: {
          departParentId: this.departParentId,
          page: 0,
          size: 10,
        },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          //console.log("travels", res.data.list);
          this.travelsInTime = res.data.list;
          this.getDoneTravelList();
        }
      });
    },
    getDoneTravelList() {
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "POST", url: "UBTZ/GetDoneTravelList" },
        data: {
          departParentId: this.departParentId,
          page: 0,
          size: 10,
        },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          this.travelsDone = res.data.list;
          //console.log("GetDoneTravelList", res.data.list);
        }
      });
    },
    showTask(e) {
      //alert(e)
      // let curu= this.planDriver.filter(x=>x.userTaskId==e.id && x.planMonth==month);
      // if(curu.length){
      this.taskDialogDtl.id = e.id;
      this.taskDialogDtl.key++;
      this.taskDialogDtl.show = true;
      //}
    },
    showTaskDtl(e, month) {
      //alert(e)
      let curu = this.planDriver.filter(
        (x) => x.userTaskId == e.id && x.planMonth == month
      );
      if (curu.length) {
        this.taskDialogDtl.id = curu[0].id;
        this.taskDialogDtl.key++;
        this.taskDialogDtl.show = true;
      }
    },
    getBgDriver(user, month) {
      let rv = "";
      let curu = this.planDriver.filter(
        (x) => x.userTaskId == user.id && x.planMonth == month
      );
      //console.log('curu', curu);
      if (curu.length) {
        //console.log('curu', curu[0]['flag']);
        //flag -1 bieleegui hugatsaa hetersen
        // -2 bieleegui heviin
        // 2 ok hugatsaandaa bielsen
        // 1 hugatsaa heterch bielse

        if (curu[0]["flag"] == 1) {
          rv = "bg-warning text-white";
        } else if (curu[0]["flag"] == 2) {
          rv = "bg-success text-white";
        } else if (curu[0]["flag"] == -1) {
          rv = "bg-danger text-white";
        } else if (curu[0]["flag"] == -2) {
          rv = "bg-gray-300";
        }
        // else{
        //     rv= 'bg-gray-300';
        // }
      }
      return rv;
    },
    getBgTrainer(user, month) {
      let rv = "";
      let curu = this.planTrainer.filter(
        (x) => x.userId == user.userId && x.planMonth == month
      );
      //console.log('curu', curu);
      if (curu.length) {
        if (curu[0]["completedCount"] == curu[0]["count"]) {
          rv = "bg-success text-white";
        } else {
          rv = "bg-gray-300";
        }
      }
      return rv;
    },
    isDrawGroup(i) {
      //if(this.mode==1) return false;
      //if(this.mode==1) return false;
      if (this.mode == 0) {
        let _fname = "departParentName";

        if (i == 0) {
          return true;
        } else if (
          this.tasks[i]["user"][_fname] != undefined &&
          this.tasks[i]["user"][_fname] != this.tasks[i - 1]["user"][_fname]
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        let _fname = "departName";

        if (i == 0) {
          return true;
        } else if (
          this.tasks3[i][_fname] != undefined &&
          this.tasks3[i][_fname] != this.tasks3[i - 1][_fname]
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    init() {
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "POST", url: "ubtz/GetProfiles" },
        data: {
          projectId: 53844,
          //objectTypeId: 138,
          skip: 0,
          size: 100,
          model: {
            locTypeId: 159166, //45726
          },
        },
        store: this.$store,
      }).then((res) => {
        if(res!=false) {
          //console.log("GetCoreList=> ", res.data.tasks);

          this.handleLoading({ isLoading: false });
          //this.init2();
          this.getTrTrainerTravelPlan(this.curYear);

          this.tasks = _.orderBy(
            res.data.tasks,
            //["user.departParentName"],
            ['user.departParentName', "departOrd"],
            ["asc", 'asc']
          );
        }
        //console.log("GetCoreList=> ", res.data.tasks);
      });
    },
    getTrTrainerTravelPlan(year) {
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "GET", url: "UBTZ/GetTrTrainerTravelPlan" },
        params: { year: year },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        this.planTrainer = res.data.list;
        //console.log('GetTrTrainerTravelPlan', res.data.list);
      });
    },
    fillPlanTrainer(user, month) {
      let rv = "";
      let curu = this.planTrainer.filter(
        (x) => x.userId == user.userId && x.planMonth == month
      );
      //console.log('curu', curu);
      if (curu.length) {
        rv = `${curu[0]["completedCount"]}/${curu[0]["count"]}`;
      }
      return rv;
    },
    insertExec(user, month) {
      let curu = this.planDriver.filter(
        (x) => x.userTaskId == user.id && x.planMonth == month
      );
      //console.log(user, month, curu);
      if (curu.length) {
        this.taskEdit.objectTypeId = 557;
        this.taskEdit.projectId = 56868;
        this.taskEdit.id = curu[0]["id"];

        this.taskEdit.render = true;
        this.$nextTick(function() {
          this.taskEdit.show = true;
        });
      } else {
        return false;
      }
    },
    planDriverExists(user, month) {
      let rv = false;
      let curu = this.planDriver.filter(
        (x) => x.userTaskId == user.id && x.planMonth == month
      );
      if (curu.length) {
        //console.log(user.task, month, curu[0]['isCompleted']);
        rv = !curu[0]["isCompleted"];
      }
      return rv;
    },
    fillPlanDriver(user, month) {
      let rv = "";
      //console.log('user', user.id);
      //planDriver

      let curu = this.planDriver.filter(
        (x) => x.userTaskId == user.id && x.planMonth == month
      );
      if (curu.length) {
        //console.log(user.task, month);
        rv = `${curu[0]["planDay"]}`;
      }
      return rv;
    },
    filterByTrainer(t, field) {
      //console.log('t', t);
      if (this.mode == 0) {
        //let _dpid= t.depart
        this.handleLoading({ isLoading: true });
        request({
          api: { method: "POST", url: "ubtz/getProfiles" },
          data: {
            projectId: 53844,
            objectTypeId: 557,
            size: 500,
            model: {
              departId: t.departId,
              //locTypeId: 159155
              userId: t.userId
            },
          },
          store: this.$store,
        }).then((res) => {
          this.handleLoading({ isLoading: false });
          this.tasks3 = _.orderBy(res.data.tasks.filter(x=>x.position!='Зааварлагч машинч'), ["departName", 'position', 'task'], ["asc", 'asc', 'asc']);
          //console.log('this.tasks3', this.tasks3.length, res.data.tasks.length);
          if (t.user != null && t.user != undefined) {
            this.getDeparts(t.user.departParentId, t.departId);
          } else {
            this.getDeparts(t.departId, t.departId);
          }

          this.trainerCurId = t.userId;
          this.getTrDriverTravelPlan(t.userId, this.curYear);
          this.$nextTick(() => {
            this.mode = 1;
          });
        });
      } else {
        this.$router.push(`/tr/travel/557/0/0/0/${t.id}/0`);
      }
    },
    getDeparts(pid, cur) {
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "GET", url: "hr/getDepartTreeData" },
        params: {
          parentId: pid,
          geChild: false,
        },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          this.departs = res.data.departs;
          this.departCurId = cur;
          this.departParentId = pid;
          //console.log('departs', this.departs);
        }
      });
    },
    getTrDriverTravelPlan(userId, year) {
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "GET", url: "UBTZ/GetTrDriverTravelPlan" },
        params: { userId: userId, year: year },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        this.planDriver = res.data.list;
        //console.log('GetTrDriverTravelPlan', res.data.list);
      });
    },

    createPlan(t, month, tp) {
      this.taskEdit.objectTypeId = 557;
      this.taskEdit.projectId = 56868;
      //console.log('tsuvaa', t);
      this.taskEdit.fillAfter.organizationTaskId = t.id;
      this.taskEdit.fillAfter.d1 = `${this.curYear}-${month}-01T00:00:00`;
      this.taskEdit.fillAfter.locTypeId = tp.id;
      this.taskEdit.fillAfter.tsuvaaId = t.departId;

      this.taskEdit.render = true;
      this.$nextTick(function() {
        this.taskEdit.show = true;
      });
    },
    taskPosted(e) {
      //s('e', e);
      //this.mode=0;
      //this.filterByTrainer(e.prms.fillAfter.organizationTaskId);
      this.getTrDriverTravelPlan(this.trainerCurId, this.curYear);
      this.editClosed();
      this.getInTimeTravelList();
    },
    editClosed() {
      this.taskEdit.render = false;
      this.taskEdit.show = false;
      this.taskEdit.id = 0;
    },
    trainerChanged(e) {
      //console.log(e.target.value);
      if (
        e.target.value == "null" ||
        e.target.value == null ||
        e.target.value == ""
      ) {
        this.mode = 0;
      } else {
        this.mode = 0;
        let _hr=this.tasks.filter(x=>x.userId==e.target.value);
        //console.log('e.target.value', e.target.value, _hr[0]);
        this.filterByTrainer({ userId: e.target.value, departId: _hr[0]['departId'] });
      }
    },
    departChanged(e) {
      // if(e.target.value=="null" || e.target.value==null || e.target.value==""){
      //     this.mode=0;
      // }else{
      this.mode = 0;
      this.filterByTrainer({
        userId: this.trainerCurId,
        departId: e.target.value,
        user: {
          departParentId: this.departParentId,
        },
      });
      // }
    },
    //   showTask(task){
    //     this.handleLoading({ isLoading: true });
    //       request({
    //         api: { url: "task/taskInheritedDetail", method: "get" },
    //         params: { id: task.id },
    //         store: this.$store,
    //       }).then((res) => {
    //         this.handleLoading({ isLoading: false });
    //         //console.log('taskDtl', res);
    //         this.taskDtl.obj= res.data.task;
    //         this.taskDtl.mdl= true;
    //       });
    //   }
  },
};
</script>
<style lang="less">
  .trdrp{
    .dropdown-toggle{
      margin: 0;
      padding: 0 5px;
      &::after{
        display: none;
      }
    }
  }
</style>